
import { CheckoutPage } from "./CheckoutPage";
import { userProfileSlice } from "./userProfileSlice";
export default CheckoutPage;
export { userProfileSlice };